import { ProgressSpinner } from 'primereact/progressspinner'

const CenteredSpinner = ({className}) => {
  return (
    <div className={`flex justify-content-center ${className}`}>
      <ProgressSpinner />
    </div>
  )
}

export default CenteredSpinner